import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Monitor, TrendingUp, ArrowRight } from 'lucide-react';
import './Home.css'; /* Include shared styles like badges */
import './Sluzby.css';

function Sluzby() {
    return (
        <div className="sluzby-page">
            <section className="sluzby-hero">
                <div className="hp-badge hp-badge-blue">
                    <span className="dot"></span>SLUŽBY
                </div>
                <h1 className="hp-h1 text-center">
                    Co pro vás mohu udělat
                </h1>
                <p className="hp-sub text-center">
                    Vyberte si oblast, kde potřebujete pomoci. Pracuji na míru — bez zbytečných balíčků a šablon.
                </p>
            </section>

            <section className="sluzby-cards">
                <div className="sluzby-card">
                    <div className="sluzby-card-icon">
                        <Target size={32} strokeWidth={2} />
                    </div>
                    <h2 className="sluzby-card-title">Strategie</h2>
                    <p className="sluzby-card-desc">Marketingová strategie, která propojí vaše cíle s reálnými výsledky. Žádné šablony — jen plán šitý na míru.</p>
                    <Link to="/strategie" className="sluzby-card-link">
                        Zjistit více <ArrowRight size={16} />
                    </Link>
                </div>

                <div className="sluzby-card">
                    <div className="sluzby-card-icon">
                        <Monitor size={32} strokeWidth={2} />
                    </div>
                    <h2 className="sluzby-card-title">Web</h2>
                    <p className="sluzby-card-desc">Weby navržené tak, aby konvertovaly — rychlé, přehledné a optimalizované pro vyhledávače.</p>
                    <Link to="/web" className="sluzby-card-link">
                        Zjistit více <ArrowRight size={16} />
                    </Link>
                </div>

                <div className="sluzby-card">
                    <div className="sluzby-card-icon">
                        <TrendingUp size={32} strokeWidth={2} />
                    </div>
                    <h2 className="sluzby-card-title">Výkon</h2>
                    <p className="sluzby-card-desc">Měřitelné výsledky přes SEO, PPC a analytiku. Víte přesně, co funguje a kde peníze přinášejí efekt.</p>
                    <Link to="/vykon" className="sluzby-card-link">
                        Zjistit více <ArrowRight size={16} />
                    </Link>
                </div>
            </section>
        </div>
    );
}

export default Sluzby;
